/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The UserCreateUserParam model module.
 * @module model/UserCreateUserParam
 * @version 1.0
 */
class UserCreateUserParam {
    /**
     * Constructs a new <code>UserCreateUserParam</code>.
     * @alias module:model/UserCreateUserParam
     * @param username {String} 
     */
    constructor(username) { 
        
        UserCreateUserParam.initialize(this, username);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, username) { 
        obj['username'] = username;
    }

    /**
     * Constructs a <code>UserCreateUserParam</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/UserCreateUserParam} obj Optional instance to populate.
     * @return {module:model/UserCreateUserParam} The populated <code>UserCreateUserParam</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new UserCreateUserParam();

            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('orgId')) {
                obj['orgId'] = ApiClient.convertToType(data['orgId'], 'Number');
            }
            if (data.hasOwnProperty('parentUserId')) {
                obj['parentUserId'] = ApiClient.convertToType(data['parentUserId'], 'Number');
            }
            if (data.hasOwnProperty('password')) {
                obj['password'] = ApiClient.convertToType(data['password'], 'String');
            }
            if (data.hasOwnProperty('role')) {
                obj['role'] = ApiClient.convertToType(data['role'], 'String');
            }
            if (data.hasOwnProperty('username')) {
                obj['username'] = ApiClient.convertToType(data['username'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {String} name
 */
UserCreateUserParam.prototype['name'] = undefined;

/**
 * @member {Number} orgId
 */
UserCreateUserParam.prototype['orgId'] = undefined;

/**
 * @member {Number} parentUserId
 */
UserCreateUserParam.prototype['parentUserId'] = undefined;

/**
 * @member {String} password
 */
UserCreateUserParam.prototype['password'] = undefined;

/**
 * @member {String} role
 */
UserCreateUserParam.prototype['role'] = undefined;

/**
 * @member {String} username
 */
UserCreateUserParam.prototype['username'] = undefined;






export default UserCreateUserParam;

